import React from 'react';
import HBMediaElement from '@honeybook/hbui/dist/components/HBMediaElement/HBMediaElement';

export const ZoomMobileLogo = () => (
    <HBMediaElement
        width={93}
        height={32}
        path="illustrations/hb-zoom-integation.png"
        alt="Prismm and Honeybook illustration"
    />
);
